import { Chip } from '@mui/material'

/**
 * Reusable SubscriptionChip component
 * Displays subscription plan with appropriate color
 * 
 * @param {string} subscription - Subscription plan (Basic, Premium, Enterprise)
 * @param {string} size - Chip size (small, medium)
 * @param {string} variant - Chip variant (filled, outlined)
 * @returns {JSX.Element} Styled chip component
 */
export function SubscriptionChip({ subscription, size = 'small', variant = 'filled' }) {
    const colors = {
        Basic: 'default',
        Premium: 'primary',
        Enterprise: 'success',
    }

    return (
        <Chip
            label={subscription}
            color={colors[subscription] || 'default'}
            size={size}
            variant={variant}
        />
    )
}
